import { render, staticRenderFns } from "./OfficeEditor.vue?vue&type=template&id=7bcd4084&"
import script from "./OfficeEditor.vue?vue&type=script&lang=ts&"
export * from "./OfficeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports